<template>
    <div>
        <config-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :setFilter="setFilter"></config-filter-link>
        <config-list-link :listLayout="listLayout" :paginationData="filterSet.page" :configData="List" :categorys="categorys"></config-list-link>
        <pagination-link :paginationLayout="paginationLayout" :type="'next'" :paginationData="filterSet.page" :setPage="setPage" :listLength="List.length" :setData="setData"></pagination-link>
    </div>
</template>

<script>
    import VuxAlert from "@/mixins/vux-alert"
    import ConfigFilterLink from "@/components/config/ConfigFilterLink";
    import ConfigListLink from "@/components/config/ConfigListLink";
    import PaginationLink from "@/components/config/PaginationLink";
    import configUtil from "@/components/config/configUtil";
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import EventBus from "@/utils/event-bus";
    const {filterConfig} = configUtil;

    export default {
        name: 'ConfigListComponent',
        components: {
            ConfigFilterLink,
            ConfigListLink,
            PaginationLink,
        },
        mixins: [ VuxAlert, filterMixins, listMixins, configUtil ],
        props: {
            configType: {},
        },
        data() {
            return{
                listLayout: '',
                filterLayout: '',
                paginationLayout: '',
                paginationType: '',
                getFunc : '',
                listApiParamSet: {},
                isCategory: false,
                searchInput: '',
                searchInputOption: 'su',
                filterDate: ['', ''],
                categorys: [],
            }
        },
        created() {
            this.initConfig();
            if(this.isCategory) {
                this.getCategory();
            }
            this.setFilterConfig(filterConfig)
            this.setParserType('url', this.$route.fullPath);
        },
        mounted() {
            this.getList(true);
        },
        computed: {
        },
        methods: {
            initConfig() {
                let conConfig = this.returnConConfig(this.configType);
                this.listLayout = conConfig.listLayout;
                this.filterLayout = conConfig.filterLayout;
                this.paginationLayout = conConfig.paginationLayout;
                this.paginationType = conConfig.paginationType;
                this.listApiParamSet = conConfig.listApiParamSet;
                this.isCategory = conConfig.isCategory;
                let pageRow = conConfig.pageRow ? conConfig.pageRow : 10;
                if(pageRow != this.filterSet.page.size) {
                    this.filterSet.page.size = pageRow;
                }

                let listOptions = {
                    url : this.$api.$config.getConfig,
                    defaultParams : this.listApiParamSet,
                }
                this.initList('api', listOptions);
            },
            setData(key, value) {
                this[key] = value;
            },
            getCategory() {



            },

        }
    }
</script>
